import React, { useState } from 'react';
import {Route, Switch} from 'react-router-dom';
import NavBar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Menu from '../Components/Menu/Menu';

export default function Layout(props) {
    const {routes} = props;
    const [menuOpen, setMenuOpen] = useState(false);

    return (
      <div>
       <NavBar menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
       <Menu menuOpen={menuOpen}/>
        <LoadRoutes routes={routes}/>   
       <Footer/> 
      </div>
    )
  }
  
  
  function LoadRoutes({ routes }) {
    return ( 
    <Switch> {
            routes.map((route, index) => (
                 <Route key = { index }
                 path = { route.path }
                 exact = { route.exact }
                 component = { route.component }
                />
            ))
        } 
        </Switch>
    );
  
  }